import React, { useState } from 'react';
import { Box, Button, Text, Image, Center } from '@chakra-ui/react';
import { PostLoginApi } from '../../../apis/Login.api';
import { useNavigate } from 'react-router-dom';
import { CustomNumberInput } from '../../atoms/CustomNumberInput';
import { BanInputType, CustomStringInput } from '../../atoms/CustomStringInput';
import { useDispatch } from 'react-redux';
import { SetRole } from '../../../redux/login/LoginSlice';
import { AxiosError } from 'axios';

interface props {
  setIsLogin: React.Dispatch<React.SetStateAction<boolean>>;
}

const GetCrewNumberInputCheckData = (addData: string | undefined) => {
  if (addData === undefined) {
    return { ViewInt: 10, ViewDigit: 0, Value: '' };
  }
  return { ViewInt: 10, ViewDigit: 0, Value: addData };
};

const GetPasswordInputCheckData = (addData: string | undefined) => {
  if (addData === undefined) {
    return { Length: 40, BanInputType: BanInputType.FullWidth, Value: '' };
  }
  return { Length: 40, BanInputType: BanInputType.FullWidth, Value: addData };
};

///const MinCrewNo = 4;
///const MinPassword = 10;

export const LoginBody: React.FC<props> = (props) => {
  const { setIsLogin } = props;
  const [crewNo, setCrewNo] = useState<string | undefined>('');
  const [password, setPassword] = useState<string | undefined>('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const LoginClickEvent = async () => {
    if (crewNo === '' || crewNo === undefined) {
      alert('乗務員番号を入力して下さい。');
      return;
    }
    /*if (crewNo.length < MinCrewNo) {
      alert('乗務員番号は' + MinCrewNo.toString() + '桁以上で入力して下さい。');
      return;
    }*/

    if (password === '' || password === undefined) {
      alert('パスワードを入力して下さい。');
      return;
    }

    /*if (password.length < MinPassword) {
      alert(
        'パスワードは' + MinPassword.toString() + '桁以上で入力して下さい。'
      );
      return;
    }*/

    const response = await PostLoginApi({
      user_no: Number(crewNo),
      password: password
    });

    if (response?.success && response.data?.headers !== undefined) {
      sessionStorage.setItem(
        'access-token',
        response.data.headers['access-token']
      );
      setIsLogin(true);
      dispatch(SetRole(response.data.data.role));
      navigate('/location');
      return;
    }

    if (
      response.message != null &&
      (response.message as AxiosError).status?.toString() === '401'
    ) {
      alert('このユーザーにはアクセス権限がありません。');
      return;
    }
    alert('ログインに失敗しました。');
    return;
  };

  return (
    <>
      <Center h='93%' bgColor='black'>
        <Box w='30%' h='260px' bgColor='white'>
          <Text
            ml={2}
            mt={5}
            fontSize={30}
            fontWeight='bold'
            textAlign='center'
          >
            運行管理システム
          </Text>
          <Box ml={6}>
            <CustomNumberInput
              CheckInfo={GetCrewNumberInputCheckData('Crew No')}
              inputValue={crewNo}
              setValue={setCrewNo}
            />

            <CustomStringInput
              CheckInfo={GetPasswordInputCheckData('Password')}
              inputValue={password}
              setValue={setPassword}
              PhohibitionCharaCheck={false}
              PasswordFlg={true}
            />
          </Box>
          <Button
            mt={5}
            ml={6}
            w='91%'
            bgColor='blue.500'
            _hover={{ bgColor: 'blue.500' }}
            _focus={{ bgColor: 'blue.500' }}
            onClick={() => LoginClickEvent()}
          >
            Log In
          </Button>
        </Box>
      </Center>
    </>
  );
};
